import React, { useEffect, useState } from 'react';
import PackageList from './PackageList';

function MathsSpecial(props) {
    
    const [mathsSpecial, setMathsSpecial] = useState([]);
    
    useEffect(() => {
        const getMathsSpecial = props.packages.filter(data => {
            return (data.productID === "PK_EP_266")
        });
        setMathsSpecial(getMathsSpecial)
      }, []);
    
    return (
        <>
            <h2 className="family-header">Secondary Maths Onscreen</h2>
                <PackageList
                packages={mathsSpecial}
                addToBasket={props.addToBasket}
                basket={props.basket}
                removePackageFromBasket={props.removePackageFromBasket}
                site={props.site}
                freeMaths={props.freeMaths}
                />
        </>
    );
}

export default MathsSpecial;